// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5713":"c2ebfc6fec531020","7237":"566e8de5a3dc39a3"}[chunkId] + ".css";
};